<div class="container">
  <div class="location">
    <a routerLink="/" aria-label="Home Page">Home</a>
    <span> › </span>
    <a>Search Results</a>
  </div>
  <h2>Search Results@if(query){ for "{{query}}"}</h2>
  <div class="content">
    <app-product-filters-panel
      [(ngModel)]="filters"
      (ngModelChange)="onFiltersChanged()"
      [disabled]="productsLoading"
    ></app-product-filters-panel>
    <div class="collection">
      <div class="action">
        <app-product-filters-button
          [(ngModel)]="filters"
          (ngModelChange)="onFiltersChanged()"
          [disabled]="productsLoading"
        ></app-product-filters-button>
        <app-product-order-by-select
          [(ngModel)]="orderBy"
          (ngModelChange)="onOrderByChanged()"
        ></app-product-order-by-select>
      </div>
      @if (productsLoading) {
      <div class="loading"><mat-spinner [diameter]="40"></mat-spinner></div>
      }@else if ( products.length>0) {

      <app-product-list [products]="products"></app-product-list>

      <mat-paginator
        [length]="total"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]"
        [hidePageSize]="true"
        [pageIndex]="page-1"
        (page)="onPageChanged($event)"
        aria-label="Select page"
      >
      </mat-paginator>
      }@else{
      <!-- <div class="empty">NO DATA</div> -->
      <nz-empty></nz-empty>
      }
    </div>
  </div>
  <app-recently-viewed-product-list></app-recently-viewed-product-list>
</div>
